module.exports = __webpack_public_path__ + "static/media/layers.ac8ffe72.svg";